import { render, staticRenderFns } from "./ProductTemplateSelect.vue?vue&type=template&id=e73a2126"
import script from "./ProductTemplateSelect.vue?vue&type=script&lang=js"
export * from "./ProductTemplateSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports